module.exports = __webpack_public_path__ + "media/images/countrysquared/pe-1ddee803af1e79cb8935169211f27758.svg";